// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/topNav/Menu.scss
// module id = 2348
// module chunks = 0